import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ title, description, to, image, eyebrow }) {
  return (
    <Link to={to} className="group block br-card overflow-hidden" data-testid="service-card">
      <div className="aspect-[16/9] overflow-hidden bg-br-paper relative">
        {image ? (
          <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" loading="lazy" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-br-paper-2 to-br-paper" />
        )}
        {/* Subtle dark overlay to keep any card-mounted text/CTAs readable. */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
      </div>
      <div className="p-5">
        {eyebrow && <div className="br-eyebrow mb-1">{eyebrow}</div>}
        <h3 className="font-display text-lg tracking-wider uppercase mb-1.5">{title}</h3>
        <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
        <div className="mt-3 flex items-center gap-1 text-br-bronze text-xs uppercase font-bold tracking-widest">
          Learn More <ArrowRight size={14} className="group-hover:translate-x-1 transition" />
        </div>
      </div>
    </Link>
  );
}
